module.exports = __webpack_public_path__ + "img/produto-STI.b073316b.png";